<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Feriado</div>      
            </div>
            <div class="card-body">
                <div class="row mb-3">
                     <div class="col-md-4">
                        <label><span class="required">*</span> Nome</label>
                        <input type="text" class="form-control" v-model="holiday.name">
                    </div>
                    <div class="col-md-4 mb-2">
                        <label><span class="required">*</span> Fixo</label>
                        <select class='form-control' v-model='holiday.fixed'>
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </select>
                    </div>
                    <div class="col-md-4" v-show="holiday.fixed == '1'">
                        <label><span class="required">*</span> Dia/Mẽs</label>
                        <input type="text" class="form-control" v-model="holiday.dayAndMonth" v-mask="'##/##'">
                    </div>
                    <div class="col-md-4" v-show="holiday.fixed == '0'">
                        <label><span class="required">*</span> Data</label>
                        <input type="date" class="form-control" v-model="holiday.specific_date">
                    </div>
                </div>
                <div class="block text-right">
                    <router-link to="/holidays" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                users: [],
                holiday: {
                    name: '',
                    fixed: '0',
                    dayAndMonth: '',
                    specific_date: '',
                }
            }
        },
        methods: {
            save: function () {
                const self = this;

                if(self.holiday.id) return self.edit();

                const api = this.$store.state.api + 'holidays';

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Feriado cadastrado com sucesso`, 'success');
                        this.$router.push('/holidays');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            edit: function () {
                const self = this;
                const api = self.$store.state.api + 'holidays/' + self.holiday.id;

                let fd = self.makeFormData();
                if(!fd) return;

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Feriado editado com sucesso`, 'success');
                        this.$router.push('/holidays');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            makeFormData: function(){
                const self = this;

                let fd  = new FormData();

                // if(!self.manualCheck.time || self.manualCheck.time.length < 8){
                //     self.$message('Erro', 'Preencha horas válidas', 'error');
                //     return false;
                // }

                fd.append('name', self.holiday.name);
                fd.append('fixed', self.holiday.fixed);

                if(self.holiday.fixed == '1'){
                    let dayAndMonth = self.holiday.dayAndMonth.split('/')
                    if(dayAndMonth.length == 2 && dayAndMonth[0].length == 2 && dayAndMonth[1].length == 2){
                        fd.append('month', dayAndMonth[1]);
                        fd.append('day', dayAndMonth[0]);
                    } else {
                        self.$message('Erro', 'Data/Mẽs inválido', 'error');
                        return false;
                    }
                } else {
                    fd.append('specific_date', self.holiday.specific_date);
                }

                if(self.holiday.id) {
                    fd.append('id', self.holiday.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            getHoliday: function(id){
                let self = this;
                let api  = self.$store.state.api + 'holidays/' + id

                self.$http.get(api)
                    .then((response) => {
                        let holiday = response.data.data[0]
                        if(holiday.fixed == '1'){
                            holiday.dayAndMonth = holiday.day + '/' + holiday.month
                        }
                        self.holiday = holiday
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            let id = self.$route.params.id;
            if(id) {
                self.getHoliday(id);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Holiday/Add.vue